<template lang="pug">
b-form-select(
  :value="value"
  :size="size"
  :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
  @input="handleInput"
  )
  option(value="" disabled selected) {{ $t("message.select_option") }}
  option(v-for="option in options" :value="option.position") {{ option.position }}
</template>

<script>
import config from "@/config";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted() {
    this.getThemeContentPosition();
  },
  methods: {
    getThemeContentPosition() {
      let url = config.getThemeContentPositionListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
      };
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
